<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0)">Registers</a>
                    </li>
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/activities">Activity Registers</router-link>
                    </li>
                    <li class="breadcrumb-item" aria-current="page" v-if="status">New Activity Register</li>
                    <li class="breadcrumb-item active" aria-current="page" v-else>Update Activity Register</li>
                </ol>
                <h4 class="main-title mb-0">Activity Register</h4>
            </div>
            <router-link to="/activities" type="submit" class="btn btn-primary" style="float: right;"><i class="ri-list-check"></i> ACTIVITY REGISTERS</router-link>
        </div>
        <div class="row">
            <div class="col-12" v-can="'activity_registers.create'">
                <form @submit.prevent="submitForm">
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">Add Activity Register</h6>
                            <h6 class="card-title" v-else>Update Activity Register</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-4">
                                    <label class="form-label">Activity Date & Time</label><span class="text-danger"> *</span>
                                    <input type="datetime-local" class="form-control" placeholder="Enter Activity Date"  :class="{'is-invalid': errors?.activity_date}" ref="activity_date" :value="convertDateFormat(activity.activity_date)" v-model="activity.activity_date" />
                                    <span v-if="errors?.activity_date" class="invalid-feedback">{{ errors?.activity_date[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Activity Status</label><span class="text-danger"> *</span>
                                    <select class="form-control" v-model="activity.activity_status" :class="{'is-invalid': errors?.activity_status}">
                                        <option value="">Select Status</option>
                                        <option value="Added">Added</option>
                                        <option value="Removed">Removed</option>
                                        <option value="Scraped">Scraped</option>
                                    </select>
                                    <span v-if="errors?.activity_status" class="invalid-feedback">{{ errors?.activity_status[0] }}</span>
                                </div>

                                <div class="col-md-4">
                                    <label class="form-label">Asset</label><span class="text-danger"> *</span>
                                    <!-- <search
                                        :class="{ 'is-invalid': errors?.asset_id }"
                                        :customClass="{ 'is-invalid': errors?.asset_id }"
                                        :initialize="activity.asset_id"
                                        id="asset_id"
                                        label="asset_name"
                                        label2="asset_code"
                                        placeholder="Select Asset"
                                        :data="assets"
                                        @input="asset => activity.asset_id = asset"
                                    >
                                    </search> -->
                                    <AssetSearch :disabled="!status" :initialize="activity.asset_name" :asset_id="activity.asset_id" @selectAsset="selectAsset($event)" ref="asset_id"></AssetSearch>
                                    <span v-if="errors?.asset_id" class="invalid-feedback">{{ errors?.asset_id[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Equipment</label><span class="text-danger"> *</span>
                                    <search
                                        :disabled="!status"
                                        :class="{ 'is-invalid': errors?.equipment_id }"
                                        :customClass="{ 'is-invalid': errors?.equipment_id }"
                                        :initialize="activity.equipment_id"
                                        id="equipment_id"
                                        label="equipment_name"
                                        label2="equipment_code"
                                        placeholder="Select Equipment"
                                        :data="equipments"
                                        @input=" equipment => activity.equipment_id = equipment"
                                    >
                                    </search>
                                    <span v-if="errors?.equipment_id" class="invalid-feedback">{{ errors?.equipment_id[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Reason</label><span class="text-danger" v-if="activity.activity_status == 'Removed' || activity.activity_status == 'Scraped'"> *</span>
                                    <search
                                        :class="{ 'is-invalid': errors?.reason_id }"
                                        :customClass="{ 'is-invalid': errors?.reason_id }"
                                        :initialize="activity.reason_id"
                                        id="reason_id"
                                        label="reason_name"
                                        label2="reason_code"
                                        placeholder="Select Reason"
                                        :data="reasons"
                                        @input=" reason => activity.reason_id = reason"
                                    >
                                    </search>
                                    <span v-if="errors?.reason_id" class="invalid-feedback">{{ errors?.reason_id[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Cost</label>
                                    <input type="number" placeholder="Enter Cost" class="form-control" :class="{'is-invalid':errors?.cost}" v-model="activity.cost" />
                                    <span v-if="errors?.cost" class="invalid-feedback">{{ errors?.cost[0] }}</span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Note</label>
                                    <textarea type="text" placeholder="Enter Note" class="form-control" :class="{'is-invalid': errors?.note}" v-model="activity.note"></textarea>
                                    <span v-if="errors?.note" class="invalid-feedback">{{ errors?.note[0] }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <router-link type="button" to="/activities" class="btn btn-danger me-2"><i class="ri-arrow-left-line fs-18 lh-1"></i> Back</router-link>
                            <button type="submit" class="btn btn-primary">
                                <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                                <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Search from "@/components/Search.vue";
import AssetSearch from "@/components/AssetSearch.vue";
import moment from "moment";
    export default {
        name: "Assets.Create",
        components: { Search,AssetSearch},
        data() {
            return {
                sample: "",
                activity: {
                    user_activity_id: "",
                    activity_no: "",
                    activity_date: "",
                    asset_id: "",
                    asset_code:"",
                    asset_name:"",
                    equipment_id: "",
                    reason_id: "",
                    cost: "",
                    note: "",
                    status: true,
                    activity_status: "",
                },
                assets: [],
                equipments: [],
                reasons: [],
                errors: [],
                status: true,
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                // vm.getAssets();
                vm.getEquipments();
                if (to.name == "Activity.Create") {
                    if(vm.$store.getters.asset_id){
                        console.log('Asset', vm.$store.getters)
                        vm.activity.asset_id = vm.$store.getters.asset_id
                        vm.getAsset()
                    }
                    vm.$refs.activity_date.focus();
                } else {
                    vm.status = false;
                    let uri = { uri: "getUserActivity", data: { user_activity_id: to.params.user_activity_id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.activity = response.data.data;
                            vm.activity.asset_id = vm.activity.asset.asset_id;
                            vm.activity.asset_code = vm.activity.asset.asset_code;
                            vm.activity.asset_name = vm.activity.asset.asset_name;

                        })
                        .catch(function (error) {
                            console.log("eerrrors",error)
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            });
        },
        mounted() {
            // this.activity.activity_date = moment().format("yyyy-MM-DD HH:MM");
            this.activity.activity_date = moment().format("YYYY-MM-DD HH:mm");
        },
        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.addUserActivity();
                } else {
                    vm.updateUserActivity();
                }
            },
            convertDateFormat(date) {
                let vm = this;
                // return moment(date).format("yyyy-MM-DD HH:MM");
                return moment(date).format("YYYY-MM-DD HH:mm");
            },
            getAssets() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getAssets" })
                    .then((response) => {
                        loader.hide();
                        vm.assets = response.data.data;
                        if(vm.$store.getters.asset_id){
                            console.log('Asset', vm.$store.getters.asset_id)
                            vm.activity.asset_id = vm.$store.getters.asset_id
                        }
                        vm.getEquipments();
                    })
                    .catch(function (error) {
                        console.log("errror--",error)
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getEquipments() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getEquipments" })
                    .then((response) => {
                        loader.hide();
                        vm.equipments = response.data.data;
                        vm.getReasons();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getReasons() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getReasons" })
                    .then((response) => {
                        loader.hide();
                        vm.reasons = response.data.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            addUserActivity() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addUserActivity", data: vm.activity })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.$router.push("/activities");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getAsset() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getAsset", data:{asset_id: vm.activity.asset_id  }})
                    .then((response) => {
                        loader.hide();
                        vm.asset_data = response.data.data;
                        vm.activity.asset_name = vm.asset_data.asset_name
                        vm.activity.asset_code = vm.asset_data.asset_code
                    })
                    .catch(function (error) {
                        console.log("errror--",error)
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            updateUserActivity() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updateUserActivity", data: vm.activity })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.$router.push("/activities");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            discard() {
                let vm = this;
                vm.activity = {};
                vm.$refs.activity_date.focus();
                vm.errors = [];
                vm.status = true;
            },

            selectAsset(e) {
                const asset = e.target.value;
                console.log("ee-asset=--",asset)
                this.activity.asset_name = asset.asset_name;
                this.activity.asset_id = asset.asset_id;
                this.activity.asset_code = asset.asset_code;

            },

        },
    };
</script>
